import { render, staticRenderFns } from "./Explanation.vue?vue&type=template&id=58d90c75"
import script from "./Explanation.js?vue&type=script&lang=js&external"
export * from "./Explanation.js?vue&type=script&lang=js&external"
import style0 from "./Explanation.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports